import { MenuItem, Text } from "@chakra-ui/react"
import { useRouter } from "next/router"
import PropTypes from "prop-types"
import { useBrandedTranslation } from "../../../../../../common/hooks/useBrandedTranslation"
import useModal from "../../../../../../common/hooks/useModal"
import { CDocument } from "../../../../../shared/Icons"
import TenderTextModal from "../../../../../shared/TenderTextModal/TenderTextModal"

const TenderTextMenuItem = ({ tenderTextId, setIsModalOpenFromMenu }) => {
  const { t } = useBrandedTranslation()
  const { locale } = useRouter()
  const { Modal, onOpen, onClose } = useModal()

  const handleOpen = () => {
    setIsModalOpenFromMenu(true)
    onOpen()
  }

  const handleClose = () => {
    setIsModalOpenFromMenu(false)
    onClose()
  }

  // Show tender texts only for German locale
  if (!tenderTextId || locale !== "de-DE") return null

  return (
    <>
      <MenuItem icon={<CDocument />} onClick={handleOpen} aria-label="Open modal to view tender texts">
        <Text fontWeight="medium">{t("pdp-article-more-tederText")}</Text>
      </MenuItem>

      <TenderTextModal
        Modal={Modal}
        title={t("pdp-tenderText-title")}
        tenderTextId={tenderTextId}
        handleClose={handleClose}
      />
    </>
  )
}

export default TenderTextMenuItem

TenderTextMenuItem.propTypes = {
  tenderTextId: PropTypes.string,
  setIsModalOpenFromMenu: PropTypes.func,
}
